import { defineStore } from 'pinia';
import axios from 'axios';

export const LocationsStore = defineStore('locations', {
    state: () => ({
        locations: {},
    }),
    actions: {
        async getLocationsBySessionCategory(sessionCategory) {
            return new Promise(async (resolve, reject) => {
                if (typeof this.locations[sessionCategory.id] !== "undefined") {
                    resolve(this.locations[sessionCategory.id]);
                    return;
                }

                try {
                    const response = await axios.post(`/wp-json/categories/v1/locations/`, {
                        sessionTypeId: sessionCategory.id,
                    }, {
                        headers: {
                            'Content-type': 'application/x-www-form-urlencoded',
                        }
                    });

                    this.locations[sessionCategory.id] = response.data;
                    resolve(response.data);
                } catch (error) {
                    reject(error);
                }
            });
        }
    },
});